import React from 'react';

import AutofillTextInput from '../../shared/components/forms/AutofillTextInput';
import TextInput from '../../shared/components/forms/TextInput';
import NumberInput from '../../shared/components/forms/NumberInput';
import FileList from '../../shared/components/forms/FileList';
import Button from '../../shared/components/forms/Button';
import ContactSuggestionItem from './ContactSuggestionItem';

const ContactForm = React.forwardRef((props, ref) => {
  return <ContactFormComponent formRef={ref} {...props} />;
});

const ContactFormComponent = ({
  errors,
  handleChange,
  contact,
  attachments,
  handleSubmit,
  contacts,
  selectContact,
  formRef,
  onClickSubmitButton,
}) => {
  const attachmentsList = () => {
    return (
      <section className="cardSection _addDepth _noBottomPadding">
        <p className="copy emphasize"> Your uploaded pages </p>
        <FileList attachments={attachments} errors={[]} />
      </section>
    );
  };

  return (
    <div className="ds-card _tight" ref={formRef}>
      {attachmentsList()}

      <section className="cardSection _noBorder _noBottomPadding">
        <p className="preamble">Step 2 of 2</p>
        <h2 className="subhead">Help us verify this transaction faster</h2>
        <p className="copy">
          Please provide your buyer's details below so we can contact them and
          verify this transaction
        </p>
      </section>

      <form onSubmit={handleSubmit} autoComplete="off">
        <section className="cardSection">
          <AutofillTextInput
            autoComplete="new-password"
            label="Full Name"
            name="full_name"
            value={contact.full_name || ''}
            error={errors.full_name}
            placeholder=""
            onChange={handleChange}
            requiredSymbol
            suggestions={contacts}
            handleSuggestionSelect={selectContact}
            renderSuggestionItem={(contact, handleSelect) => (
              <ContactSuggestionItem
                contact={contact}
                handleSelect={handleSelect}
                key={contact.id}
              />
            )}
          />
          <NumberInput
            label="Business Landline Number"
            name="landline_number"
            value={contact.landline_number || ''}
            error={errors.landline_number}
            tip={'e.g. 02 252 5558'}
            placeholder=""
            onChange={handleChange}
            requiredSymbol
          />
          <TextInput
            label="Mobile number"
            name="mobile_number"
            value={contact.mobile_number || ''}
            error={errors.mobile_number}
            tip={'e.g. +63 916 888 4444'}
            placeholder=""
            onChange={handleChange}
          />
          <TextInput
            label="Email Address"
            name="email_address"
            value={contact.email_address || ''}
            error={errors.email_address}
            placeholder=""
            tip={'e.g. juan.delacruz@email.com'}
            onChange={handleChange}
            requiredSymbol
          />
        </section>
        <section className="cardSection">
          <p className="byline _finePrint _alignCenter">
            By submitting, you give consent to First Circle to contact your
            buyer and verify the details of this transaction. Please inform your
            buyer that a representative will get in touch.
          </p>
        </section>
        <Button
          test="submit-button"
          className="--full"
          label="Submit Application"
          type="submit"
          onClick={onClickSubmitButton}
        />
      </form>
    </div>
  );
};

export default ContactForm;



// WEBPACK FOOTER //
// ./src/features/trade_documents/components/ContactForm.js